import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {Form,Button ,Input,Checkbox,Icon,Modal,Tabs} from 'antd';
import history from '@/containers/history';
import {initialPage,refreshCheckCode} from '@/api/api';
import SignLab from '../sign/signLab';
import SignUser from '../sign/signUser';
import md5 from 'md5';
import GVerify from '@/api/gVerify';
import styles from './login.module.css';
import '@/styles/antdReset.css';

const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 12 },
};
const formTailLayout = {
    wrapperCol: { span: 12, offset: 6 },
};
class Login extends Component {
    constructor(props){
        super(props);
        console.log(props);
        let httpStr = window.location.host.startsWith('http') ? '' : 'http://';
        this.state={
            rememberPassChecked:true,
            sureLoading:false,
            loginBgPath:"",
            // logoPath:"",
            modalVisible:false,
            initialData:{},
            signTabList:[],
            signScs:null,
            checkCode:'',
            logoPath:httpStr + window.location.host + '/labpro/resources/skin/9/web/logo.png'
        }
        this.loginSubmit=this.loginSubmit.bind(this);
        this.rememberPassChange=this.rememberPassChange.bind(this);
        this.nameBlur=this.nameBlur.bind(this);
        this.setValue = this.setValue.bind(this);
        this.generateCheckCode = this.generateCheckCode.bind(this)
        this.inipage = this.inipage.bind(this)
        
    }

    componentDidMount(){
        this.inipage();

    }

    inipage(){
        const that=this;
        initialPage({},res=>{
            console.log(res);
            // document.getElementById("v_container").onclick = function(){

            //     refreshCheckCode({},res=>{                    
            //         if(res.statusCode === 1000){
            //             //alert(res.checkCode);
            //             that.generateCheckCode(res.checkCode);
            //         }
            //     })
            // }
            if(res.statusCode === 1000){
                that.generateCheckCode(res.checkCode)
                let initialData = res;
                delete initialData.statusCode;
                delete initialData.message;
                that.setValue('initialData',initialData);
                 // 初始化主题
                window.less.modifyVars && window.less.modifyVars({
                    '@primary-color':'#'+res.color,
                    '@btn-primary-bg':'#'+res.color,
                });
                // 设置注册渲染tab框
                const signTabList_lab = [
                    {
                        key:'0',
                        title:"实验室注册",
                        content:<SignLab setValue={that.setValue}></SignLab>
                    },{
                        key:'3',
                        title:"人员注册",
                        content:<SignUser signType={3} setValue={that.setValue}></SignUser>
                    }
                ];
                const signTabList_user = [
                    {
                        key:'1',
                        title:"内部人员注册",
                        content:<SignUser signType={0} setValue={that.setValue}></SignUser>
                    },{
                        key:'2',
                        title:"外部人员注册",
                        content:<SignUser signType={1} setValue={that.setValue}></SignUser>
                    }
                ];
                let signTabList = initialData.userFlag ? signTabList_lab : signTabList_user;
                localStorage.setItem('userFlag',initialData.userFlag)
                that.setValue('signTabList',signTabList);
                let httpStr = window.location.host.startsWith('http') ? '' : 'http://';
                //that.setValue('loginBgPath', httpStr + window.location.host + '/labpro' + res.dirPath + 'login.jpg');
                //that.setValue('logoPath', httpStr + window.location.host + '/labpro' + res.dirPath + 'logo.png');
                
            }
        },err=>{
            console.log(err)
        })
    }

    // 生成验证码
    generateCheckCode(checkCode){
        // var verifyCode = new GVerify({
        //     id:"v_container",
        //     code:checkCode,
        // });

        document.getElementById("v_container").innerHTML=checkCode;
    }

    rememberPassChange=(e)=>{
        console.log(e.target)
        this.setState({
            // rememberPassChecked: e.target.checked,
        });
    }

    

    // 登陆
    loginSubmit=(e)=>{
        const that=this;
        e.preventDefault();
        const {rememberPassChecked} = this.state;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                that.setState({
                    sureLoading:true
                });
                that.props.login(values,rememberPassChecked,that.setValue,that.generateCheckCode)
            }
        });
    }

    setValue=(feild,value)=>{
        this.setState({
            [feild]:value
        })
    }

    // 自动填入密码
    nameBlur=(e)=>{
        let pass=localStorage.getItem('userName_' + e.target.value);
        if(pass){
            this.props.form.setFieldsValue({
                password:pass
            })
        }
    }

    render(){
        const that=this;
        const {loginBgPath,logoPath,modalVisible,initialData,signType,signTabList,signScs} = this.state;
        const { getFieldDecorator } = this.props.form;
        return(
            <div className={styles.login} id="login">
                <h1>
                    <img src={logoPath} alt="logo"/>
                </h1>
                
                <p className={styles.surport}>Copyright © 2018-2019 湖南巨擘科技有限公司 版权所有<br/>客服QQ:2471427571&nbsp;&nbsp;&nbsp;客服电话：18670037735&nbsp;&nbsp;&nbsp;7*24小时为您服务</p>
                
                <Form onSubmit={this.loginSubmit} className={styles.login_form}>
                    <FormItem {...formItemLayout} >
                    </FormItem>
                    <FormItem {...formItemLayout}  label="用户名">
                        {getFieldDecorator('username',{
                            rules: [
                                {required: true,message: '请输入用户名'},
                                // {max:11,patern:/^1[34578]\d{9}$/,message: '请输入正确的手机号码!'}
                            ],
                            validateTrigger:'onBlur',
                        })(
                            <Input 
                                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                placeholder="请输入用户名"
                                size='large'
                                autoComplete="off" disableautocomplete='true'
                                onBlur={value => that.nameBlur(value)}
                            />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout}  label="密&nbsp;&nbsp;&nbsp;码">
                        {getFieldDecorator('password',{
                            rules: [
                                {required: true, message: '请输入密码'},
                                {max:40,message:'请输入正确密码!'}
                            ],
                            validateTrigger:'onBlur'
                        })(
                            <Input 
                                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                placeholder="请输入密码"
                                size='large'
                                type="password"
                            />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="验证码">
                        {getFieldDecorator('checkCode',{
                            rules: [
                                {required: true, message: '请输入验证码'},
                                {max:4,message:'请输入正确的验证码!'}
                            ],
                            validateTrigger:'onBlur'
                        })(
                            <Input 
                                placeholder="请输入验证码"
                                size='large'
                                style={{width:'45%'}}
                                autoComplete="off"
                            />
                        )}
                        <div 
                        onClick={()=>{
                            that.inipage();
                        }} className={styles.validBox} id="v_container"></div>
                    </FormItem>
                    <FormItem {...formTailLayout}>
                        <div className={styles.login_btns}>
                            <Button htmlType="submit" type="primary" className={styles.signLab_btn} size="large" loading={this.state.sureLoading}>登录</Button>
                           <span className={styles.login_sign}><a href="/signLab" >实验室注册</a><br></br><a href="/signUser" >实验室用户注册</a></span>
                        </div>
                    </FormItem>
                </Form>
                <Modal
                centered
                closable = {false}
                visible={modalVisible}
                footer={null}
                wrapClassName="signWrapper"
                onCancel={()=>this.setValue('modalVisible',false)}
                >
                    <Tabs defaultActiveKey={signTabList[0] ? signTabList[0].key : '0'} className='signTabs'>
                        {signTabList.map(x=>{
                            return(
                                <TabPane tab={x.title} key={x.key}>{x.content}</TabPane>
                            )
                        })}
                    </Tabs>
                </Modal>
                {signScs &&
                    <Modal
                    centered
                    footer={null}
                    visible = {true}
                    onCancel={()=>this.setValue('signScs',null)}
                    >
                        <div className={styles.signScsBox}>
                            <h2 className="tc">
                                <img src="../images/send.png" alt="注册成功" width="56"/>
                                <p className="mt10">注册成功</p>
                            </h2>
                            <p>您的账号已注册成功，我们将尽快为您开通。如需加急，请电话联系{this.state.initialData.phone}，谢谢！</p>
                            <p className="tc"><Button onClick={()=>that.setValue('signScs',null)}>关闭</Button></p>
                        </div>
                    </Modal>
                }
            </div>
        )
    }
}

export default Form.create({})(Login);

